import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { SocialProofTicker } from './components/SocialProofTicker';
import { PainSection } from './components/PainSection';
import { FeaturesSection } from './components/FeaturesSection';
import { TrackProgressSection } from './components/TrackProgressSection';
import { DailyReportSection } from './components/DailyReportSection';
import { ComparisonSection } from './components/ComparisonSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { OfferSection } from './components/OfferSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-bg text-ink font-sans selection:bg-rose/20 selection:text-rose-deep" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProofTicker data-id="element-4" />
        <PainSection data-id="element-5" />
        <FeaturesSection data-id="element-6" />
        <TrackProgressSection data-id="element-7" />
        <DailyReportSection data-id="element-8" />
        <ComparisonSection data-id="element-9" />
        <HowItWorksSection data-id="element-10" />
        <BenefitsSection data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <OfferSection data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <FAQSection data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
    </div>;
}